import { useEffect, useState } from 'react';
import { tableHeader, tableData, containerTwo, containerOne, title } from '../utils/style';
import { url } from '../utils/config';
import axios from 'axios';
import { toast } from 'react-toastify';
import loaderStateAtom from '../atoms/loaderStateAtom';
import { useRecoilState } from 'recoil';
import uiConfigAtom from '../atoms/uiConfigAtom';
import backButton from "../assets/backButton.png";
import { useNavigate } from 'react-router-dom';
import navHeaderAtom from '../atoms/navHeaderAtom';
import certification from '../assets/icons/certification.png';
import TrainingCard from '../reusable_components/TrainingCard';

function Certification() {
    const [ certifications, setCertifications ] = useState([]);
    const [ showLoader, setShowLoader ] = useRecoilState(loaderStateAtom)
    const [ uiConfig ] = useRecoilState(uiConfigAtom)
    const [ header, setHeader ] = useRecoilState(navHeaderAtom)
    let navigate = useNavigate();

    const data = [
        {
            id: 1,
            image: certification,
            title: 'Sunroof Troubleshoot',
            lessons: '30',
            duration: '8h 30min'
        },
        {
            id: 2,
            image: certification,
            title: 'Sunroof Troubleshoot',
            lessons: '30',
            duration: '8h 30min'
        },
        {
            id: 3,
            image: certification,
            title: 'Sunroof Troubleshoot',
            lessons: '30',
            duration: '8h 30min'
        }
    ]

    const style = {
        backgroundColor: uiConfig?.table?.headerColor?.hex,
        color: uiConfig?.table?.fontColor?.hex
    }

    useEffect(() => {
        setHeader('Trainings')
    }, [])

    async function getCertifications() {
        try {
            setShowLoader(true)
            const reqUrl = url + '/courses';
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const {data} = await axios.get(reqUrl, { headers });
            console.log(data.data);
            //set data in state
            setShowLoader(false)
        } catch (error) {
            setShowLoader(false)
            toast.error(error.response.data.message, { autoClose: 3000 })
        }
    }


    async function requestTraining(id) {
        try {
            setShowLoader(true)
            console.log(id)
            // const reqUrl = url + '/training_request/' + certificationId;
            // const token = window.localStorage.getItem('token');
            // const headers = { authorization: `bearer ${token}` };
            // const data = await axios.get(reqUrl, { headers });
            // console.log(data.data);
            //set data in state
            setShowLoader(false)
        } catch (error) {
            setShowLoader(false)
            toast.error(error.response.data.message, { autoClose: 3000 })
        }
    }

    return(
        <div className={containerOne}>
            <div className={title}>Choose A Certification/Training</div>
            <div className='grid grid-cols-2 gap-1'>
                {
                    data.map(d => 
                    <TrainingCard 
                        id={d.id} 
                        image={d.image} 
                        title={d.title} 
                        lessons={d.lessons} 
                        duration={d.duration}
                        requestTraining={requestTraining}
                    />)
                }
            </div>
        </div>
    )
}

export default Certification;